var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "options" },
    _vm._l(_vm.options, function(option, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "option",
          class: { active: option === _vm.selectedOption },
          style: { width: _vm.optionWidth },
          on: {
            click: function($event) {
              return _vm.onSelect(option)
            }
          }
        },
        [
          option === _vm.selectedOption
            ? _c("img", {
                attrs: { src: require("../../assets/img/check-white.svg") }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.formatCallback(option)))])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f0605a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f0605a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/Choice.vue
// module id = null
// module chunks = 